import type { JSX, MouseEvent } from 'react';

import { MAlert, MRadio, MTypography, WarningAlertDescription } from 'src/lib';
import { Color } from 'src/styles';

import * as Styles from './PaymentTypeHeader.styles';

interface PaymentTypeHeaderProps {
  checked: boolean;
  title: string;
  subtitle?: string | JSX.Element;
  disclaimer?: string | null;
  dataTestId?: string;
  onDisclaimer?: () => void;
}

export const PaymentTypeHeader = ({
  title,
  subtitle,
  disclaimer,
  checked,
  onDisclaimer,
  dataTestId,
}: PaymentTypeHeaderProps) => {
  const _onDisclaimer = () => {
    if (onDisclaimer) {
      onDisclaimer();
    }
  };

  // The Collapse header handles selection. Without this, a click on the radio label also
  // clicks its input, the header toggles twice and the panel closes again.
  const onRadioClick = (event: MouseEvent) => {
    event.preventDefault();
  };

  return (
    <div className={Styles.header}>
      <div className={Styles.container} onClick={onRadioClick}>
        <MRadio checked={checked}>
          <MTypography variant='body1' testId={dataTestId}>
            {title}
          </MTypography>
        </MRadio>
      </div>
      <div className={Styles.subContainer}>
        {disclaimer && (
          <MAlert
            type='warning'
            showIcon={false}
            description={<WarningAlertDescription onClick={_onDisclaimer} text={disclaimer} />}
            className={Styles.alert}
          />
        )}
        {subtitle && (
          <MTypography variant='body2' color={Color.Gray7} className={Styles.subtitle}>
            {subtitle}
          </MTypography>
        )}
      </div>
    </div>
  );
};
